"use client";

import { useNewsletterSubscribe } from "@/framework/hooks/common";
import { IconForwardArrow } from "@repo/assets/images";
import { ErrorMessage, LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
const NewsletterSubscribe = ({
  placeholder
}) => {
  const {
    handleSubmit,
    handleValidation,
    formValues,
    formErrors,
    isPending,
    message,
    isSuccess
  } = useNewsletterSubscribe();
  const t = useTranslations("Footer");
  return <form onSubmit={handleSubmit} className="md:me-14 lg:me-0 lg:min-w-[480px]" data-sentry-component="NewsletterSubscribe" data-sentry-source-file="NewsletterSubscribe.jsx">
      <div className="relative">
        <div className="flex border border-black">
          <input type="email" placeholder={placeholder || t("subscribeForTheLatestFashionHaulAndSurprisingDeals")} className="flex-1 border-none bg-gray-50 px-4 py-2 text-base text-gray-500 outline-none placeholder:text-xs placeholder:text-gray-400 md:placeholder:text-sm rtl:text-right" name="email" value={formValues?.email || ""} onChange={handleValidation} />
          <button type="submit" disabled={isPending} className="bg-button-primary-bg hover:bg-button-primary-hover flex h-11 items-center justify-center p-3 transition-colors disabled:opacity-50">
            {isPending ? <LoadingDots className="bg-white" /> : <IconForwardArrow className="text-button-primary-iconColor rtl:rotate-180" />}
          </button>
        </div>
      </div>
      <ErrorMessage message={formErrors?.email} data-sentry-element="ErrorMessage" data-sentry-source-file="NewsletterSubscribe.jsx" />
      {message && <div className={cx("mt-2 text-sm", {
      "text-green-600": isSuccess,
      "text-red-600": !isSuccess
    })}>
          <p>{message}</p>
        </div>}
    </form>;
};
export default NewsletterSubscribe;